import { createTheme } from '@mantine/core';

/**
 * The Mantine theme.
 *
 * Styling is Mantine CSS variables and theme tokens only — no Tailwind, no
 * stylesheet of our own beyond what a component genuinely needs. A second
 * styling system in the same app means two places to look for why something is
 * the colour it is.
 */
export const theme = createTheme({
  primaryColor: 'indigo',

  // Danish bookkeeping is read in Danish. The stack is the system UI font, so
  // the app looks native on Windows, macOS and Android rather than shipping a
  // webfont for text that is mostly numbers.
  fontFamily:
    '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif',

  // Money and account codes are compared column-to-column. A tabular figure
  // font keeps digits the same width so the decimal points line up.
  fontFamilyMonospace:
    'ui-monospace, SFMono-Regular, "SF Mono", Consolas, "Liberation Mono", monospace',

  headings: { fontWeight: '600' },

  defaultRadius: 'md',

  components: {
    // A table of postings is dense by nature; the default padding makes a
    // twenty-line entry scroll for no reason.
    Table: {
      defaultProps: { verticalSpacing: 'xs', horizontalSpacing: 'md' },
    },
  },
});

/**
 * Right-aligned tabular figures, for any cell holding money.
 *
 * A shared class rather than a prop on each cell: an amount that is not
 * right-aligned is hard to scan against the one above it, and getting that
 * wrong in one table out of ten is worse than not aligning at all.
 */
export const MONEY_CELL = 'money-cell';
